import { render, staticRenderFns } from "./BaseMessageComposeWarning.vue?vue&type=template&id=2fa64c5f&"
import script from "./BaseMessageComposeWarning.vue?vue&type=script&lang=js&"
export * from "./BaseMessageComposeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports